import { ArrowLeftIcon } from '@carboncopyco/icons';
import { Button, TextLargeParagraph } from '@carboncopyco/ui';

const BrowserWindowErrorScreen = ({ onGoBack }: { onGoBack: () => void }) => {
  return (
    <div className="flex flex-1 flex-col grow relative justify-center align-center">
      <div className="mb-4">
        <TextLargeParagraph
          label="Oops, seems like the URL you typed does not exist "
          color="text-ds-natural-600"
        />
      </div>
      <Button
        link
        leftIcon={<ArrowLeftIcon />}
        label="Back to previous page"
        onClick={onGoBack}
      />
    </div>
  );
};

export default BrowserWindowErrorScreen;
